export enum ComponentId {
  ARE_OTHER_PEOPLE_INVOLVED = "areOtherPeopleInvolved",
  PERSONS = "persons",
}
